import { useSite } from "@/lib/site-context";
import { CheckCircle2 } from "lucide-react";

export default function Rates() {
  const { rates } = useSite();
  const r = rates || {};

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#D9A62E] font-mono-piki font-semibold">Transparent Rates</div>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-white">Rates & Packages</h1>
      <p className="mt-3 text-[#A3A3A3] max-w-2xl">Clear pricing across every category. All rates are placeholders — edit them from the admin panel to match your business.</p>

      {/* Daily/Weekly tiers */}
      <section className="mt-12">
        <h2 className="font-display text-2xl font-bold text-white mb-5">Daily & Multi-day Rates</h2>
        <div className="piki-card overflow-hidden" data-testid="rates-daily-tier-table">
          <div className="grid grid-cols-4 gap-4 p-5 border-b border-[#2E2E2E] text-xs font-mono-piki uppercase tracking-widest text-[#737373]">
            <div>Category</div><div>1 Day</div><div>3+ Days</div><div>7+ Days</div>
          </div>
          {(r.daily_tiers || []).map((t, i) => (
            <div key={i} className="grid grid-cols-4 gap-4 p-5 border-b border-[#2E2E2E]/60 last:border-0 items-center">
              <div className="text-sm font-semibold text-white">{t.category}</div>
              <div className="text-[#D9A62E] font-mono-piki font-semibold">${t["1_day"]}</div>
              <div className="text-[#D9A62E] font-mono-piki font-semibold">${t["3_day"]}</div>
              <div className="text-[#D9A62E] font-mono-piki font-semibold">${t["7_day"]}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Insurance */}
      <section className="mt-14">
        <h2 className="font-display text-2xl font-bold text-white mb-5">Insurance & Coverage</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {(r.insurance_options || []).map((ins, i) => (
            <div key={i} className="piki-card p-6" data-testid="rates-insurance-compare-card">
              <div className="font-display font-bold text-xl text-white">{ins.name}</div>
              <div className="mt-3">
                <span className="text-3xl font-extrabold text-[#D9A62E] font-mono-piki">${ins.price_per_day}</span>
                <span className="text-xs text-[#737373] font-mono-piki ml-1">/ day</span>
              </div>
              <div className="mt-4 text-sm text-[#A3A3A3]">Excess: <span className="text-white font-semibold">${ins.excess}</span></div>
              <div className="mt-1.5 text-xs text-[#737373]">{ins.note}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Extras */}
      <section className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="piki-card p-6">
          <h2 className="font-display text-xl font-bold text-white mb-4">Optional Extras</h2>
          <ul className="space-y-3">
            {(r.extras || []).map((e, i) => (
              <li key={i} className="flex items-center justify-between text-sm">
                <span className="text-[#D4D4D4] flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-[#D9A62E]" /> {e.name}</span>
                <span className="text-[#D9A62E] font-mono-piki font-semibold">${e.price_per_day ?? e.price_flat}{e.price_per_day ? "/day" : " flat"}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="piki-card p-6">
          <h2 className="font-display text-xl font-bold text-white mb-4">Fees, Deposit & Delivery</h2>
          <ul className="space-y-3">
            <li className="flex items-center justify-between text-sm text-[#D4D4D4]"><span>Additional Driver</span><span className="text-[#D9A62E] font-mono-piki font-semibold">${r.additional_driver_fee ?? "—"}</span></li>
            <li className="flex items-center justify-between text-sm text-[#D4D4D4]"><span>Security Deposit</span><span className="text-[#D9A62E] font-mono-piki font-semibold">${r.deposit ?? "—"}</span></li>
            <li className="flex items-center justify-between text-sm text-[#D4D4D4]"><span>Airport Delivery</span><span className="text-[#D9A62E] font-mono-piki font-semibold">${r.airport_delivery_fee ?? "—"}</span></li>
            {(r.other_fees || []).map((f, i) => (
              <li key={i} className="flex items-center justify-between text-sm text-[#D4D4D4]"><span>{f.name}</span><span className="text-[#D9A62E] font-mono-piki font-semibold">${f.price}</span></li>
            ))}
          </ul>
        </div>
      </section>

      <p className="mt-10 text-xs text-[#737373]">All prices shown in {r.currency || "USD"}. Placeholder values — customise from the admin panel.</p>
    </div>
  );
}
